import { Routes, Route, Link } from 'react-router-dom';
import { HelmetProvider } from "react-helmet-async";
import Home from './Home';
import About from './About';
import Skills from './Skills';
import Projects from './Projects';
import Contact from './Contact';
import Footer from './Footer';
import './App.css';


function App() {
  return (
    <div className="flex flex-col min-h-screen bg-gray-900">
      <nav className="nav bg-gray-800 py-4 flex justify-center gap-6 text-white">
        <Link to="/">Home</Link>
        <Link to="/about">About</Link>
        <Link to="/skills">Skills</Link>
        <Link to="/projects">Projects</Link>
        <Link to="/contact">Contact</Link>
      </nav>

      <main className="flex-grow">
        <HelmetProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/skills" element={<Skills />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </HelmetProvider>
      </main>

      <Footer />
    </div>
  );
}

export default App;
